import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(options) {
    // http://localhost:3000/api_publica/v1/gestion_economica/formas_pago
    return cifraClient.get('/api_publica/v1/gestion_economica/formas_pago', options);
  },
};
